import { render, staticRenderFns } from "./BibliographyIntegrationDataTable.vue?vue&type=template&id=f7a7f6b4&"
import script from "./BibliographyIntegrationDataTable.vue?vue&type=script&lang=ts&"
export * from "./BibliographyIntegrationDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
